const STORAGE_KEY = "boxs_client_session_id";

function generateClientSessionId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  const a = Date.now().toString(16);
  const b = Math.random().toString(16).slice(2);
  const c = Math.random().toString(16).slice(2);
  return `sess-${a}-${b}${c}`;
}

/**
 * Stable per browser-tab session id (sessionStorage). Sent as X-Client-Session-Id on API calls.
 */
export function getClientSessionId() {
  if (typeof window === "undefined" || typeof window.sessionStorage === "undefined") {
    return null;
  }

  try {
    let id = sessionStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = generateClientSessionId();
      sessionStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch (_err) {
    return null;
  }
}
